import parse from 'html-react-parser'
export default function RoadmapElement(props) {
  const {headShark, order, title, description} = props

  return (
    <div className='roadmapElement'>
      <img src={headShark} alt='head shark' />
      <div className='title'>
        <div className='special'>Q</div>
        <div className='titleOne'>uest {order}</div>
        <div className='titleTwo'>{parse(title)}</div>
      </div>
      <div className='description'>
        <div>{parse(description)}</div>
      </div>
    </div>
  )
}